import script from "./StudentRiskDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentRiskDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentRiskDialog.vue?vue&type=style&index=0&id=1f2b1962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2b1962"]])

export default __exports__